import { Box, Container, Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { CSSProperties } from 'react';
import palette from '@ui/palette';
import Typography from '@ui/Typography';
import Button from '@ui/Button';

const useStyles = makeStyles({ name: 'UpgradeBanner' })(theme => ({
  root: {
    background: palette.gray_25,
    zIndex: theme.mixins.banner.zIndex,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: theme.mixins.banner.height,
  },
  container: {
    height: '100%',
  },
  upgradeButton: {
    backgroundColor: palette.gray_500,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: palette.gray_0,
    '&:hover': {
      backgroundColor: palette.gray_400,
    },
    '&:focus': {
      backgroundColor: palette.gray_400,
      outline: `2px solid ${palette.gray_400}`,
    },
  },
}));

interface UpgradeBannerProps {
  trialEnded: boolean | 0 | undefined;
  timeLeft: string;
  takesRemaining: number;
  onClick: () => void;
  style?: CSSProperties;
  showUpgradeButton: boolean;
  isBusinessTrial: boolean;
}

const UpgradeBanner = React.forwardRef<HTMLElement, UpgradeBannerProps>(
  (
    {
      trialEnded,
      timeLeft,
      takesRemaining,
      onClick,
      style = {},
      showUpgradeButton,
      isBusinessTrial,
    },
    ref
  ) => {
    const { classes } = useStyles();
    return (
      <Paper ref={ref} component="aside" className={classes.root} style={style}>
        <Container className={classes.container}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography variant="pMd" color="gray_1000">
              {trialEnded ? (
                `Thank you for trying WellSaid Labs! Need a longer trial? Contact us.`
              ) : (
                <>
                  {`You have `}
                  <b>{`${timeLeft}`}</b>
                  {` and `}
                  <b>{`${takesRemaining} take${
                    takesRemaining === 1 ? '' : 's'
                  }`}</b>
                  {` remaining in your ${
                    isBusinessTrial ? 'Business ' : ''
                  }Trial Subscription. `}
                </>
              )}
            </Typography>
            {showUpgradeButton && (
              <Box marginLeft={1}>
                <Button
                  variant="overlay"
                  size="small"
                  onClick={onClick}
                  className={classes.upgradeButton}
                >
                  {'Upgrade Now'}
                </Button>
              </Box>
            )}
          </Box>
        </Container>
      </Paper>
    );
  }
);

export default UpgradeBanner;
